import store from '@/store/'
import { viUiEnabled } from '@/utils/features'

// Virtual Influencers is internal-staff only (admin + project-manager), or
// anyone in impersonate mode — only admin/PM can start an impersonation, so the
// flag is itself a staff signal. Mirrors the server-side isInternalStaff().
// This blocks direct-URL access; the server-side `is_internal` middleware is
// the real gate.
// eslint-disable-next-line no-unused-vars
export default function internalStaff({ from, next, router, to }) {
  // SRR-2981: the VI UI is hidden unless VIRTUAL_INFLUENCERS_UI_ENABLED.
  if (!viUiEnabled()) {
    return router.push({ name: 'dashboard' })
  }

  if (store.getters['user/is_impersonate']) {
    return next()
  }

  const userType = store.getters['user/type']

  if (!['admin', 'project-manager'].includes(userType)) {
    return router.push({ name: 'dashboard' })
  }

  return next()
}
